<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-feedback" lazy-validation>
        <h2 style="margin: 0% auto;"><b>Feedback Baru</b></h2>
        <h5>Feedback > Tambahkan Feedback</h5>
        <v-layout row wrap>

          <!-- Bagian Umum -->
          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama" name="nama" v-model="nama">
            </v-text-field>
            <small v-if="!isName" class="alert">Nama Minimal 3 karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-building" label="Instansi" name="instansi" v-model="instansi">
            </v-text-field>
            <small v-if="!isInstansi" class="alert">Instansi Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="email" label="Email" name="email" v-model="email" type="email">
            </v-text-field>
            <small v-if="!isRegex" class="alert">Masukan Alamat Email. contoh: agroforestcape@gmail.com</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-textarea prepend-icon="comment" label="Kritik dan Saran" name="feedback" v-model="feedback" outline>
            </v-textarea>
            <small v-if="!isFeedback" class="alert">Masukan Feedback</small>
          </v-flex>
        </v-layout>        

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="primary" form="tambahkan-feedback" @click="getFeedback" :disabled="!isComplete">Tambahkan Feedback</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: null,
    modal: false ,

    nama: null,
    instansi: null,
    email: null,
    feedback: null,

    // Form Check
    reg: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,

  }),

  computed: {
    isComplete () {
      return ((this.email && this.reg.test(this.email)) && (this.nama && this.nama.length > 3) && (this.instansi && this.instansi.length > 3) && (this.feedback));
    },
    
    isRegex () {
      return (this.email && this.reg.test(this.email));
    },

    isName () {
      return (this.nama && this.nama.length > 3);
    },

    isInstansi () {
      return (this.instansi && this.instansi.length > 3);
    },

    isFeedback () {
      return (this.feedback);
    },

  },

  methods: {

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_FEEDBACK');
      // return '/pemerintah';
    },

    getFeedback (){
      localStorage.feedbackNama = this.nama,
      localStorage.feedbackInstansi= this.instansi,
      localStorage.feedbackEmail = this.email,
      localStorage.feedbackContent = this.feedback,

      localStorage.currentDateFeedback = moment().format('DD-MM-YYYY');

      window.getApp.$emit('APP_FEEDBACK_SUCCESS');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
